import {SurfaceComponentIcons, WSPIconName, WSPIcons} from '@mintdata-wsp/resources/icons/WSPIcons';

const SurfaceIcons:SurfaceComponentIcons = WSPIcons.visualDesigner.components.surface;

export class SurfaceIconsMap
{
    public static readonly DEFAULT_ICON:WSPIconName = WSPIcons.visualDesigner.components.Gears;

    public static readonly BundleIdToIconsMap =
    {
        'mintdata:mint-components':
        {
            'table'             : SurfaceIcons.Table,
            'box'               : SurfaceIcons.Box,
            'button'            : SurfaceIcons.Button,
            'togglebuttonset'   : SurfaceIcons.ToggleButtonSet,
            'buttongroup'       : SurfaceIcons.ButtonGroup,
            'card'              : SurfaceIcons.Card,
            'checkbox'          : SurfaceIcons.Checkbox,
            'dateinput'         : SurfaceIcons.DateInput,
            'daterangeinput'    : SurfaceIcons.DateRangeInput,
            'dropdown'          : SurfaceIcons.Dropdown,
            'picklist'          : SurfaceIcons.Dropdown,
            'image'             : SurfaceIcons.Image,
            'icon'              : SurfaceIcons.Icon,
            'label'             : SurfaceIcons.Label,
            'linkbutton'        : SurfaceIcons.LinkButton,
            'map'               : SurfaceIcons.Map,
            'navigation'        : SurfaceIcons.Tabs, // TODO: replace
            'numericinput'      : SurfaceIcons.NumericInput,
            'paragraph'         : SurfaceIcons.Paragraph,
            'progressbar'       : SurfaceIcons.ProgressBar,
            'radiobuttongroup'  : SurfaceIcons.RadioButtonGroup,
            'rangeslider'       : SurfaceIcons.RangeSlider,
            'slider'            : SurfaceIcons.Slider,
            'sqleditor'         : SurfaceIcons.SqlEditor,
            'soundplayer'       : SurfaceIcons.SoundPlayer,
            'spreadsheet'       : SurfaceIcons.Spreadsheet,
            'switch'            : SurfaceIcons.Switch,
            'tabs'              : SurfaceIcons.Tabs,
            'richtexteditor'    : SurfaceIcons.RichTextEditor,
            'textarea'          : SurfaceIcons.TextArea,
            'textinput'         : SurfaceIcons.TextInput,
            'chart'             : SurfaceIcons.Chart,
            'calendar'          : SurfaceIcons.Calendar,
            'filepicker'        : SurfaceIcons.FilePicker,
            'tooltipdecorator'  : SurfaceIcons.TooltipDecorator,
            'popovercontainer'  : SurfaceIcons.PopoverContainer,
            'timeinput'         : SurfaceIcons.TimeInput,
            'splitview'         : SurfaceIcons.SplitView,
            'text'              : SurfaceIcons.Label,
            'videoplayer'       : SurfaceIcons.VideoPlayer,
            'heatmap'           : SurfaceIcons.Heatmap,
            'twilio'            : SurfaceIcons.Twilio,
        }
    }
}
